
export const DOMAIN_LOCAL       = 'local.europlan.nl';
export const DOMAIN_PRODUCTION  = 'www.europlan.nl';
export const DOMAIN_STAGING     = 'test.europlan.nl';

export const IS_LOCAL           = DOMAIN_LOCAL      === location.hostname;
export const IS_PRODUCTION      = DOMAIN_PRODUCTION === location.hostname;
export const IS_STAGING         = DOMAIN_STAGING    === location.hostname;

export const ID_GTM_PRODUCTION  = 'GTM-W8V5CTNG';
